import React, { useEffect, useState, useCallback } from 'react'
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { TextField, Button} from '@mui/material';

export default function CreateTc() {
    const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = `${now.getMonth() + 1}`.padStart(2, '0');
        const day = `${now.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [data, setData] = useState([]);
    const [srNo, setSRNo] = useState('');
    const [dob, setDOB] = useState('');
    const [uploadedDocument, setUploadedDocument] = useState(null);
    const [documentSizeExceeds, setDocumentSizeExceeds] = useState(null);
    const [fromDate, setFromDaate] = useState(getCurrentDate());
    const [toDate, setToDate] = useState(getCurrentDate());
    const [errors, setErrors] = useState('');
    const [DeleteId, setDeleteId] = useState(''); 
    const [isDeleted, setIsDeleted] = useState(false); 
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const [loading, setLoading] = useState(false);
    const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'Dashboard', url: '/Dashboard' }]);
    const location = useLocation();

    const handleSRNoChange = (e) => {
        const selectedValue = e.target.value
        setSRNo(selectedValue)
        setErrors((prevErrors) => ({
          ...prevErrors,
          srNo: selectedValue ? '' : 'Enter SRNo'
        }));
    };

    const handleDOBChange = (e) => {
        const selectedValue = e.target.value
        setDOB(selectedValue)
        setErrors((prevErrors) => ({
          ...prevErrors,
          dob: selectedValue ? '' : 'Enter Date Of Birth'
        }));
    };

    const handleDocumentClick = () => {
        document.getElementById("uploadedDocument").click();
    };
    
    const handleDocumentchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          if (file.size > 200 * 1024) {
            setDocumentSizeExceeds('Document uploaded exceeds maximum file size limit (200 KB).');
            setUploadedDocument(null);
          } else {
            setDocumentSizeExceeds(null);
            setUploadedDocument(file);
          }
        }
    };
    
    const handleRemoveFile = () => {
        setUploadedDocument(null);
        setDocumentSizeExceeds(null);
        const documentInput = document.getElementById("uploadedDocument");
        if (documentInput) {
            documentInput.value = '';
        }
    };

    const handleFromDateChange = (e) => {
        setFromDaate(e.target.value)
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value)
    };

    const handleReset = () => {
        setSRNo('');
        setDOB('');
        handleRemoveFile();
    }; 

    const fetchDetails = useCallback(async () => {
      try {
        const response = await fetch(`/api/getTc`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fromDate, toDate }),
        });
  
        if (response.ok) {
          const Data = await response.json();
          setData(Data);
        } else {
          console.error("Error fetching filtered data");
        }
      } catch (error) {
        console.error("Error fetching filtered data:", error);
      }
    }, [fromDate, toDate]);
  
    useEffect(() => {
      fetchDetails();
    }, [fetchDetails, fromDate, toDate]);

    const handleSubmit = async (e) => {
        setLoading(true);     
        if (isSubmitting) {
          return; 
        }

        if (!srNo || !dob || !uploadedDocument) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                srNo: !srNo ? 'SRNo is required' : prevErrors.srNo,
                dob: !dob ? 'Date Of Birth is required' : prevErrors.dob,
            }));

            if (!uploadedDocument) {
                setDocumentSizeExceeds('Document Is Required')
            } 

            setLoading(false);
            setIsSubmitting(false);
            return;
        }  

        setIsSubmitting(true);   
        const formData = new FormData();
        formData.append('srNo', srNo);
        formData.append('dob', dob);
        formData.append('uploadedDocument', uploadedDocument);

        try {
            const response = await fetch(`/api/CreateTc`, {
                method: 'POST',
                body: formData,
            });
            if (response.ok) {
                const data = await response.json();
                toast.success(data.message);
                handleReset();
                fetchDetails();
            } else {
                const data = await response.json();
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error uploading', error);
        } finally {
            setLoading(false);
        }
        setIsSubmitting(false);
    }

    const handleConfirmation = async (TMID) => {
        setIsDeleted(true);
        setDeleteId(TMID)
    };

    const handleCancel = async () => {
        setIsDeleted(false);
        setDeleteId('')
    };

    const handleDelete = async (TMID) => {
      try {
        const response = await fetch(`/api/DeleteTc/${TMID}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          setData((prevData) => prevData.filter(item => item.TMID !== TMID));
          const data = await response.json();
          toast.success(data.message);
          setIsDeleted(false);
          setDeleteId('')
        } else {
          const data = await response.json();
          toast.error(data.error);
          setIsDeleted(false);
          setDeleteId('')
        }
      } catch (error) {
        console.error('Error deleting Subjects:', error);
      }
    };
    
    useEffect(() => {
      const currentRoute = location.pathname;
      const newBreadcrumbs = generateBreadcrumbs(currentRoute);
      setBreadcrumbs(newBreadcrumbs);
    }, [location]);
  
    const generateBreadcrumbs = (currentRoute) => {
      const breadcrumbsArray = [{ label: 'Dashboard', url: '/Dashboard' }];
  
      const routeParts = currentRoute.split('/').filter(Boolean);
      let urlSoFar = '';
      routeParts.forEach((part) => {
        urlSoFar += `/${part}`;
        breadcrumbsArray.push({ label: part, url: urlSoFar });
      });
  
      return breadcrumbsArray;
    };
   
  return (
    <>
      <div className='mt-24 mx-2'>
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumbs.map((breadcrumb, index) => (
                <li key={index} className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}>
                  {index === breadcrumbs.length - 1 ? (
                    breadcrumb.label
                  ) : (
                    <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
                  )}
                </li>
              ))}
            </ol>
        </nav>
        <div className='shadow-sm p-2 mb-3 bg-white rounded'>
          <div className='row d-flex align-items-center'>
            <div className='col-md-6 mb-2'>
                <TextField label="SRNo" variant="standard" fullWidth value={srNo} onChange={handleSRNoChange} helperText={errors.srNo} error={!!errors.srNo}/>
            </div>
            <div className='col-md-6 mb-2'>
                <TextField label="Date Of Birth" variant="standard" type='date' fullWidth value={dob} onChange={handleDOBChange} helperText={errors.dob} error={!!errors.dob}  InputLabelProps={{shrink: true}}/>
            </div>
            <div className='col-12 mb-2'>
                <div className={`d-flex items-center border rounded-4 ${uploadedDocument ? 'd-none' : ''}`} onClick={handleDocumentClick} >
                  <div>
                    <button  className="me-2 rounded-4 btn btn-warning" type="button" >Upload Transfer Certificate</button>
                  </div>
                  <div className="narrowFormats"><p className='mb-0'>DOC, DOCx, PDF, RTF | Max: 200 KB</p></div>
                </div>
                <input className="d-none" type="file" id="uploadedDocument" accept=".doc,.docx,.pdf,.rtf"  onChange={handleDocumentchange} />
                {uploadedDocument && (
                  <div className='mt-1'>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                          <strong>{uploadedDocument.name}</strong> ({(uploadedDocument.size / 1024 / 1024).toFixed(2)} MB)
                      </div>
                      <button className="btn btn-outline-danger btn-sm ms-2" type="button" onClick={handleRemoveFile}>Remove</button>
                    </div>
                  </div>
                )}
                {documentSizeExceeds &&(<span className='text-danger' style={{fontSize:'12px'}}>{documentSizeExceeds}</span>)}
            </div>
            <div className='col-6 mb-2'>
                <Button variant="outlined" color="primary" fullWidth onClick={handleSubmit}>Save</Button>
            </div>
            <div className='col-6 mb-2'>
                <Button variant="outlined" color="secondary" fullWidth onClick={handleReset}>Reset</Button>
            </div>
          </div>
        </div>
        <div className='shadow-sm p-2 mb-3 bg-white rounded'>
          <div className='row d-flex align-items-center'>
            <div className='col-6 mb-2'>
                <TextField label="From Date" variant="standard" fullWidth type='date' value={fromDate} onChange={handleFromDateChange} InputLabelProps={{shrink: true}} />
            </div>
            <div className='col-6 mb-2'>
                <TextField label="To Date" variant="standard" fullWidth type='date' value={toDate} onChange={handleToDateChange} InputLabelProps={{shrink: true}} />
            </div>
          </div>
        </div>
        <div className='shadow mb-5 rounded scrollOnXaxis' style={{ maxHeight: '100vh', overflowY: 'auto' }}>
            <table className='table table-nowrap mb-0 mt-0'>
              <thead className='table-primary' style={{ position: 'sticky', top: '0', zIndex: '1', marginTop: '1rem'}}>
                <tr style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <th>#</th>
                  <th>SRNo</th>
                  <th>DOB</th>
                  <th>TC</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
              {data.map((item, index) => (
                  <tr key={index} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <td>{index + 1}</td>
                    <td>{item.SRNo}</td>
                    <td>{item.DOB.slice(0, 10)}</td>
                    <td><a href={`/Documents/${item.PDF}`} target="_blank"  rel="noopener noreferrer"><i className='bi bi-file-pdf-fill fs-6'></i></a></td>
                    <td><span className='inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/10' onClick={() => handleConfirmation(item.TMID)}><i className="bi bi-trash3-fill fs-6"></i></span></td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
      </div>
      {isDeleted && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${isDeleted ? 'show' : ''}`} style={{ display: isDeleted ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
            <div className="modal-header">
              <h5 className="modal-title">Delete <strong>TC?</strong></h5>
            </div>
            <div className="modal-body">
              <p>This Will Delete Tc <span className='text-danger'>Permannently</span></p>
              <div className='d-flex flex-row-reverse '>
              <button className='btn btn-danger mx-2' onClick={() => handleDelete(DeleteId)}>Delete</button>
              <button className='btn btn-secondary mx-2' onClick={handleCancel}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div id="preloader">
          <div className="bar-container">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
          <h1>Loading...</h1>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

